module.exports = __webpack_public_path__ + "img/norcott_b1.ce181e21.jpg";